import { enableFade } from 'core/handlers/FadeHandler'
import { enableTap } from 'core/handlers/TapHandler'
import { signal } from 'services/SignalsService'

export default class WinAnimationEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)
    this.activate = fade
    enableTap(this, () => {
      signal.dispatch('WIN-TAP', false)
    })
  }
}
